import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { Button, IconButton, SelectDropDown, Typography } from 'procyon-ui'
import React from 'react'
import { enqueueNotification } from 'Utils/Helpers'
import PrettyViewObject from 'Utils/PretteyViewObject'
import { FullScreenContentModal } from 'V2Components'

export default function StepContent({
  type,
  step,
  selectedOS,
  setSelectedOS,
  config,
  showInstructionModal,
  setShowInstructionModal
}) {
  const handleCopyAgentUrl = (url) => {
    navigator.clipboard.writeText(url)
    enqueueNotification(`agent url copied to clipboard!`, 'info')
  }

  const handleCopyCmd = (value) => {
    navigator.clipboard.writeText(value)
    enqueueNotification(`command copied to clipboard!`, 'info')
  }

  const getInstructionByOsType = (osType) => {
    if (osType === 'rhel') {
      return (
        <>
          <Typography variant='h5' className='mb-4'>
            Instruction for RHEL / CentOS (RPM x86_64)
          </Typography>

          <div>
            <Typography variant='body-semiBold'>Download the RPM package</Typography>
            <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center text-wrap wrap-now justify-between rounded p-2 font-mono text-sm overflow-x-auto'>
              {
                'curl -O https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/rpm/procyon-server-agent-x86_64.rpm'
              }
              <IconButton
                style={{ width: 20 }}
                icon={faCopy}
                variant='gray'
                onClick={() =>
                  handleCopyCmd(
                    'curl -O https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/rpm/procyon-server-agent-x86_64.rpm'
                  )
                }
              />
            </pre>
          </div>

          <Typography className='py-3' variant='h5'>
            OR
          </Typography>

          <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm text-wrap wrap-now'>
            {
              'wget https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/rpm/procyon-server-agent-x86_64.rpm'
            }
            <IconButton
              style={{ width: 20 }}
              icon={faCopy}
              variant='gray'
              onClick={() =>
                handleCopyCmd(
                  'wget https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/rpm/procyon-server-agent-x86_64.rpm'
                )
              }
            />
          </pre>
          <div className='my-3'>
            <Typography variant='h5'>Install the RPM package</Typography>
            <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm text-wrap wrap-now'>
              {'sudo rpm -ivh procyon-server-agent-x86_64.rpm'}
              <IconButton
                style={{ width: 20 }}
                icon={faCopy}
                variant='gray'
                onClick={() => handleCopyCmd('sudo rpm -ivh procyon-server-agent-x86_64.rpm')}
              />
            </pre>
          </div>
        </>
      )
    }

    if (osType === 'debian_amd') {
      return (
        <>
          <Typography variant='h5' className='mb-4'>
            Debian / Ubuntu AMD64
          </Typography>

          <div>
            <Typography variant='body-semiBold'>Download the DEB package</Typography>
            <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center text-wrap wrap-now justify-between rounded p-2 font-mono text-sm overflow-x-auto'>
              {
                'curl -O https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_amd64.deb'
              }
              <IconButton
                style={{ width: 20 }}
                icon={faCopy}
                variant='gray'
                onClick={() =>
                  handleCopyCmd(
                    'curl -O https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_amd64.deb'
                  )
                }
              />
            </pre>
          </div>

          <Typography className='py-3' variant='h5'>
            OR
          </Typography>

          <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm text-wrap wrap-now'>
            {
              'wget https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_amd64.deb'
            }
            <IconButton
              style={{ width: 20 }}
              icon={faCopy}
              variant='gray'
              onClick={() =>
                handleCopyCmd(
                  'wget https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_amd64.deb'
                )
              }
            />
          </pre>
          <div className='my-3'>
            <Typography variant='h5'>Install the DEB package</Typography>
            <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm text-wrap wrap-now'>
              {'sudo dpkg -i procyon-server-agent_amd64.deb'}
              <IconButton
                style={{ width: 20 }}
                icon={faCopy}
                variant='gray'
                onClick={() => handleCopyCmd('sudo dpkg -i procyon-server-agent_amd64.deb')}
              />
            </pre>
          </div>
        </>
      )
    }

    if (osType === 'debian_arm') {
      return (
        <>
          <Typography variant='h5' className='mb-4'>
            Debian / Ubuntu ARM64
          </Typography>

          <div>
            <Typography variant='body-semiBold'>Download the DEB package</Typography>
            <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center text-wrap wrap-now justify-between rounded p-2 font-mono text-sm overflow-x-auto'>
              {
                'curl -O https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_arm64.deb'
              }
              <IconButton
                style={{ width: 20 }}
                icon={faCopy}
                variant='gray'
                onClick={() =>
                  handleCopyCmd(
                    'curl -O https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_arm64.deb'
                  )
                }
              />
            </pre>
          </div>

          <Typography className='py-3' variant='h5'>
            OR
          </Typography>

          <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm text-wrap wrap-now'>
            {
              'wget https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_arm64.deb'
            }
            <IconButton
              style={{ width: 20 }}
              icon={faCopy}
              variant='gray'
              onClick={() =>
                handleCopyCmd(
                  'wget https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_arm64.deb'
                )
              }
            />
          </pre>
          <div className='my-3'>
            <Typography variant='h5'>Install the DEB package</Typography>
            <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm text-wrap wrap-now'>
              {'sudo dpkg -i procyon-server-agent_arm64.deb'}
              <IconButton
                style={{ width: 20 }}
                icon={faCopy}
                variant='gray'
                onClick={() => handleCopyCmd('sudo dpkg -i procyon-server-agent_arm64.deb')}
              />
            </pre>
          </div>
        </>
      )
    }

    if (osType === '' && type === 'WindowAgent') {
      return (
        <>
          <Typography variant='h5' className='mb-4'>
            Instruction for Microsoft Windows
          </Typography>

          <div>
            <Typography variant='body-semiBold'>
              Download the windows guest agent executable(exe)
            </Typography>
            <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm text-wrap wrap-now'>
              {
                'https://ping-crestone.s3.us-west-2.amazonaws.com/windows-guest-agent/WindowsGuestAgent.exe'
              }
              <IconButton
                style={{ width: 20 }}
                icon={faCopy}
                variant='gray'
                onClick={() =>
                  handleCopyCmd(
                    'https://ping-crestone.s3.us-west-2.amazonaws.com/windows-guest-agent/WindowsGuestAgent.exe'
                  )
                }
              />
            </pre>
          </div>
          <div>
            <Typography variant='body-semiBold'>
              Choose an install location(dir) on the box
            </Typography>
            <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm text-wrap wrap-now'>
              {'c:Program FilesPing One Guest Agent'}
            </pre>
          </div>
          <div>
            <Typography variant='body-semiBold' className='mt-2'>
              Once installed create a procyon-guest-agent.env file on the box at a temporary
              location and copy config provided in first step. Copy this file into the the install
              location overwriting the file present at the location.
            </Typography>
          </div>
        </>
      )
    }
  }

  switch (step) {
    case 0:
      return (
        <div>
          <Typography variant='h3'>Create Env File</Typography>
          {type === 'WindowAgent' ? (
            <div className='space-y-2 my-4'>
              <Typography variant='body-semiBold'>
                Create the directory (if not already present):
              </Typography>
              <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm overflow-x-auto'>
                {'mkdir "C:\\ProgramData\\Procyon"'}
                <IconButton
                  style={{ width: 20 }}
                  icon={faCopy}
                  variant='gray'
                  onClick={() => handleCopyCmd('mkdir "C:\\ProgramData\\Procyon"')}
                />
              </pre>
              <Typography variant='body-semiBold'>
                {' '}
                Then open Notepad and create the env file:
              </Typography>
              <pre className='flex items-center justify-between bg-[#1e1e1e] text-[#dcdcdc] rounded p-2 font-mono text-sm overflow-x-auto'>
                {'notepad "C:\\ProgramData\\Procyon\\procyon-guest-agent.env"'}
                <IconButton
                  style={{ width: 20 }}
                  icon={faCopy}
                  variant='gray'
                  onClick={() =>
                    handleCopyCmd('notepad "C:\\ProgramData\\Procyon\\procyon-guest-agent.env"')
                  }
                />
              </pre>
            </div>
          ) : (
            <div className='space-y-2 my-4'>
              <Typography variant='body-semiBold'>
                Create the directory (if not already present):
              </Typography>
              <pre className='bg-[#1e1e1e] text-[#dcdcdc] flex items-center justify-between rounded p-2 font-mono text-sm overflow-x-auto'>
                {'sudo mkdir -p /var/lib/procyon'}
                <IconButton
                  style={{ width: 20 }}
                  icon={faCopy}
                  variant='gray'
                  onClick={() => handleCopyCmd('sudo mkdir -p /var/lib/procyon')}
                />
              </pre>
              <Typography variant='body-semiBold'>Create the file and open it:</Typography>
              <pre className='flex items-center justify-between bg-[#1e1e1e] text-[#dcdcdc] rounded p-2 font-mono text-sm overflow-x-auto'>
                {'sudo vi /var/lib/procyon/procyon-guest-agent.env'}
                <IconButton
                  style={{ width: 20 }}
                  icon={faCopy}
                  variant='gray'
                  onClick={() => handleCopyCmd('sudo vi /var/lib/procyon/procyon-guest-agent.env')}
                />
              </pre>
            </div>
          )}

          <div className='space-y-1 mt-5'>
            <Typography variant='body-regular'>
              Paste the below content inside the file & save it.
            </Typography>
            <PrettyViewObject data={config} />
          </div>
        </div>
      )
    case 1:
      return (
        <div className='space-y-4'>
          <Typography variant='h3'>
            {type === 'WindowAgent' ? 'Install Window Guest Agent' : 'Install Server Guest Agent'}
          </Typography>
          {type === 'WindowAgent' ? (
            <Typography variant='body-regular'>
              Download the windows guest agent executable(exe) setup file and run  it in your
              windows domain controller windows box.
            </Typography>
          ) : (
            <Typography variant='body-regular'>
              Download and install the server guest agent based on your operating system and
              architecture. The service will start automatically after installation, bringing up the
              proxy container.
            </Typography>
          )}

          <div className='space-y-2'>
            <Typography variant='h5' className='font-semibold'>
              Download for your OS:
            </Typography>

            {type === 'WindowAgent' ? (
              <div className='flex flex-col md:flex-row gap-3 items-start'>
                <Button
                  variant='primary'
                  onClick={() =>
                    handleCopyAgentUrl(
                      'https://ping-crestone.s3.us-west-2.amazonaws.com/windows-guest-agent/WindowsGuestAgent.exe'
                    )
                  }
                >
                  Copy Microsoft Windows Agent Url
                  <IconButton style={{ width: 20 }} icon={faCopy} variant='primary' />
                </Button>
                <Button variant='grayBlue' onClick={() => setShowInstructionModal(true)}>
                  Show Instructions
                </Button>
              </div>
            ) : (
              <div className='flex flex-col md:flex-row gap-3 items-start'>
                <SelectDropDown
                  menuItems={[
                    { label: 'Select your OS / Architecture', value: '', disabled: true },
                    {
                      label: 'RHEL / CentOS (RPM x86_64)',
                      value: 'rhel',
                      selected: selectedOS === 'rhel'
                    },
                    {
                      label: 'Debian / Ubuntu AMD64',
                      value: 'debian_amd',
                      selected: selectedOS === 'debian_amd'
                    },
                    {
                      label: 'Debian / Ubuntu ARM64',
                      value: 'debian_arm',
                      selected: selectedOS === 'debian_arm'
                    }
                  ]}
                  value={selectedOS}
                  onChange={(val) => setSelectedOS(val?.target?.value ?? val)}
                />

                {selectedOS && (
                  <>
                    <Button
                      variant='primary'
                      onClick={() => {
                        const url =
                          selectedOS === 'rhel'
                            ? 'https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/rpm/procyon-server-agent-x86_64.rpm'
                            : selectedOS === 'debian_amd'
                            ? 'https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_amd64.deb '
                            : 'https://ping-crestone.s3.us-west-2.amazonaws.com/server-guest-agent/debian/amd64/procyon-server-agent_arm64.deb'
                        handleCopyAgentUrl(url)
                      }}
                    >
                      Copy agent Url
                      <IconButton style={{ width: 20 }} icon={faCopy} variant='primary' />
                    </Button>
                    <Button variant='grayBlue' onClick={() => setShowInstructionModal(selectedOS)}>
                      Show Instructions
                    </Button>
                  </>
                )}
              </div>
            )}
          </div>
          {showInstructionModal && (
            <FullScreenContentModal
              children={
                <>
                  {getInstructionByOsType(selectedOS)}
                  <div className='mt-4 flex justify-end gap-4'>
                    <Button
                      variant='gray'
                      onClick={() => {
                        setShowInstructionModal(!showInstructionModal)
                      }}
                    >
                      Close
                    </Button>
                  </div>
                </>
              }
            />
          )}
        </div>
      )

    default:
      return null
  }
}
